import React from 'react';
import PropTypes from 'prop-types';

import SecondaryTitle from '../SecondaryTitle';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalTitle = ({
  children,
}) => (
  <SecondaryTitle>
    {children}
  </SecondaryTitle>
);

ModalTitle.propTypes = propTypes;

export default ModalTitle;
